<template>
    <div :class="['hpImpRange',getPlatformClass,visible ? 'visible':'']">      
        <div :class="['implantCont',isFadedout===true ? 'impFadedout' : '']">
           <div>
            <ul class="itemImages">
              <li v-for="(item,index) in platformItems" :key="'plat__'+item.catalog_no || index">
                <div @click="onImgClicked(index,item.catalog_no)" :class="['itemInfo',selectedProduct == item.catalog_no ? 'selected':'']" >
                   <img :src="'https://www.mis-implants.com/upload/catalog/products/large/'+item.catalog_no+'.png'"/>
                  <span>{{item.catalog_no}}</span>
                </div>
              </li>
            </ul>
          </div> 

          <div class="itemTitle">
              <!-- {{selectedProduct}} -->
          </div>          
        </div>

        <!-- Platform bar  -->
        <div :class="['platformBarCon',plaformIndex>-1 ? 'mounted':'mounted']" style="border:solid 0px red;">
          <platformbar 
            ref="pbar1"
            v-bind:sectionType = "sectionType"
            v-bind:affectOtherSections = "false"
            v-bind:sectionIndex = "2"
            v-bind:sectionContentData = "componentData"
            skinMode = "light"
            @platform-change="onPlatformChange" 
            @item-change="onItemChange">
          </platformbar>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { splitLines } from "@/utils";
import platformbar from "@/views/com/platformbar.vue";
/* import splitter from "@/views/com/splitter.vue"; */
/* splitter */

export default 
{
    components:{platformbar},
    props: {
        sectionType:String,
        sectionIndex:Number,
        visible:Boolean,
        sectionDataIndex:Number,
        isNavOpen: Boolean,
        componentData:Object

    },
    data()
    {
        return {
            //platformItems:[],
            debug:"",
            isFirstElement:true,
            plaformIndex:0,
            selectedProduct:'',
            selectedProductImg:'',
            itemx:[],
            isFadedout:true
        }
    },
    watch: {
      /*
      '$store.state.siteVisibleSection': function() {
        var vm=this;
        let _siteVisibleSection = this.$store.state.siteVisibleSection;
        if(_siteVisibleSection==2)
        {
          vm.$refs.pbar1.doSomething();
          //section is scrolled in
          //Select default platform (if not selected)
          //alert("select now");
        }
      }*/
    },
    mounted()
    {
        var vm = this;
        //setTimeout(() => {
          //vm.platformItems = vm.minisite_data.SECTIONS.filter(x=>x.section == "implant_range")[0];    
        //}, 1000);
      

        //alert("sectionType="+this.sectionType+" sectionIndex="+this.sectionIndex);
        //sectionType:String,
        //sectionIndex:Number,        

/*         var pageSections = this.pageLayoutData.children[0].children;
        var techTabsSection = pageSections.filter(x => x.type == "propage-technical");
        var targetNodes = techTabsSection[0].children[0].children;
        var targetNode = targetNodes.filter(x => x.template == this.sectionType)[0];
 */
        //this.debug = targetNode;        
        //techTabsSection;//techTabsSection.children[0];//.children[this.sectionIndex];
        //alert("pageSections[0]:"+pageSections[0]);
        //var pageSection = pageSections.filter(x => x.type == "propage-technical");
        //alert("pageSection="+pageSection.type);
        //var techTabData = pageSection.children[0].children[this.sectionIndex];
        //alert("techTabData="+techTabData);

    },
    methods:
    {
      getSiteTechTabData()
      {
        var pageSections = this.pageLayoutData.children[0].children;
        var techTabsSection = pageSections.filter(x => x.type == "propage-technical");
        var targetNodes = techTabsSection[0].children[0].children;
        var targetNode = targetNodes.filter(x => x.template == this.sectionType)[0];
        return targetNode;
      },
      findNodeRecursive(data, key, value) {
        // Check if current data matches the criteria
        if (data && typeof data === 'object') {
          if (data[key] === value) {
            return data;
          }

          // If the current level is an array, iterate through its elements
          if (Array.isArray(data)) {
            for (const item of data) {
              const result = findNodeRecursive(item, key, value);
              if (result) return result;
            }
          } else {
            // If it's an object, check all its properties recursively
            for (const k in data) {
              if (typeof data[k] === 'object') {
                const result = findNodeRecursive(data[k], key, value);
                if (result) return result;
              }
            }
          }
        }
        return null;
      },
      onImgClicked(index,catalogNo)
      {
        //alert("item clicked:"+index);
        //call the child component method to change the index
        this.$refs.pbar1.changeItemIndex(index);
        this.onItemChange(catalogNo);
      },
      //...mapActions(["xSetPlatform"]),
      onPlatformChange(plaformIndex)
      {
        var vm = this;   
        //alert(this.plaformIndex);
        //alert(plaformIndex);
        if(this.plaformIndex!=plaformIndex || vm.isFirstElement)
        {
          vm.isFirstElement =false;          
          vm.isFadedout = true;
          
          setTimeout(() => {
            this.plaformIndex = plaformIndex;
            vm.isFadedout = false;
          }, 900);
        }
      },
      onItemChange(catalogNo)
      {
        var vm = this;        
        var APP_SITE_NAME = this.minisite_data.SITE_NAME;
        //vm.isFadedout = true;        
        //setTimeout(() => {
          //load the product image and description 
          //change bg color according to the platform
          vm.selectedProduct = catalogNo;
          //vm.selectedProductImg = "content/"+APP_SITE_NAME+"/img/implants/"+catalogNo+".png";
          //vm.selectedProductImg = "https://www.mis-implants.com/upload/catalog/products/thumbs/"+catalogNo.trim()+".png";
        //}, 500);

        //setTimeout(() => {
          //vm.isFadedout = false;
        //}, 900);

      },
      getStyleIndex(index){
        return "--index:"+index;
      }
    },
    computed:{
      ...mapState(["pageLayoutData","xSelectedPlatform","minisite_data","minisite_data_implantsrange"]),
        getPlatformClass()
        {
          //We can finally animate CSS gradient:
          //https://dev.to/afif/we-can-finally-animate-css-gradient-kdk
          return this.plaformIndex>-1 ? "platform_"+this.plaformIndex: '';
        },
        sectionData(){
            //tempData = this.minisite_data.SECTIONS.filter(x=> x.section == dataSectionName)[0];
            return this.minisite_data.SECTIONS.filter(x=>x.section == "implant_range")[0];//[this.sectionDataIndex];
            //section == implant_range 
        },
        theMinisiteData(){
            //tempData = this.minisite_data.SECTIONS.filter(x=> x.section == dataSectionName)[0];
            return this.minisite_data;
        },

        platformItems()
        {
          if (
            !this.minisite_data_implantsrange ||
            !this.minisite_data_implantsrange.platforms ||
            !this.minisite_data_implantsrange.platforms[this.plaformIndex]
          ) {
            return [];
          }
          return this.minisite_data_implantsrange.platforms[this.plaformIndex].items || [];
          //return this.componentData.platforms[this.plaformIndex].items;
        }

    }
};

</script>






<style lang="css" scoped>

    ul.itemImages
    {
      list-style: none;
      display: inline-flex;
      flex-direction: row;
      margin: auto;
      align-self: center;
      border: solid 0px blue;
    }
    ul.itemImages li
    {
      width: 110px;
      height: 220px;
      /* border: solid 2px red; */
      color: #000;
      display: flex;
      position: relative;
    }
    .itemInfo
    {
      text-align: center;
      align-self: flex-end;
      background-position: center bottom;
      background-repeat: no-repeat;
      opacity: 0.3;
      transition: all ease 0.4s;
    }
    .itemInfo.selected
    {
      opacity: 1;
    }
    .itemInfo img
    {
      /* width: 50%; */
      width: 3.5vw;
      height: auto;
      /* transform: scale(0.3); */
      transform-origin: center center;
      /* border: solid 2px green; */
      /* border: solid 2px red; */
      position: relative;
    }
    .itemInfo span
    {
      display: block;
      font-size: 12px;
      color: #202020;
      text-align: center;      
      width: 100%;
      padding-top: 10px;
    }
     


    @property --c {
      syntax: '<color>';
      inherits: false;
      initial-value: red;
    }
    .hpImpRange.visible
    {
      display: block;      
    }
    .hpImpRange
    {      
      display: block;
      /* border: solid 5px #000; */
      background: transparent;
        /* position:relative; */
        width: 100%;
        height: 100%;   
/*         position: relative;      */
        /* z-index: 100; */
/*         display: grid;
        align-items: center;
 */

      /* //var(--dark-blue);         needed for firefox to have a valid output */
      /*
        --c:var(--dark-blue); 
        transition:--c 0.6s;
        background: radial-gradient(circle, var(--c) 0%,var(--dark-blue) 50%);
        */
    }
    
    .hpImpRange.platform_0{--c:#2a2512;}
    .hpImpRange.platform_1{--c:#241128;}
    .hpImpRange.platform_2{--c:#241128;}
    .hpImpRange.platform_3{--c:#0f250e;}

    .hpImpRange .container
    {
      width: 100vw;
    }
    .hpImpRange .title
    {
        font-size: 18px !important;
        font-weight: 100 !important;
        font-weight: 400 !important;        
        letter-spacing: -0.5px;
        color: var(--text-blue);
        text-align:left;        

        position:absolute;
        top:0px;left: 0px;
        padding-left: max(180px, 10vw);
        top:100px;
        
    }
    .hpImpRange .SelectPlatform
    {
/*       top:calc(50% - 70px);
      transform: translateY(-50%);
 */      color:#202020;
      width: 100%;
      text-align: center;
      /* position: absolute; */
      font-size: 16px;
      font-weight: 300;
    }
    .hpImpRange .platformBarCon
    {
      padding-top: 50px;
        text-align: left;
      transition: all 1s cubic-bezier(0.645, 0.045, 0.355, 1.000);
      /* position: absolute;bottom: 30px; */
      /* transform: translateY(-50%); */
      width: 100%;
    }
    .hpImpRange .platformBarCon.mounted
    {
      /* top:calc(100vh - 120px); */
      bottom: 30px;
    }    
    .implantCont
    {
      /* position: absolute; */
      /* top:calc(50% - 100px); */
      /* transform: translateY(-50%); */
      width: 100%;
      text-align: center;
      color:#fff;
      opacity: 1;
      transition: all ease 0.4s;
      height: calc(100% - 240px);
      display: flex;
      align-items: flex-end;
      justify-content: center;
    }
    .implantCont.impFadedout
    {
      opacity: 0;
    }
    .implantCont .itemImg
    {
      height: 36vh;width:auto;
    }
    .implantCont .itemTitle
    {
      padding-top: 20px;
      font-size: 14px;color: #202020;
      font-weight: 300;text-align: center;
    }

  @media (hover: hover) {
  }

  @media (max-width: 850px) { 
    ul.itemImages li
    {
        width: 14vw;
        height: 220px;
    }
    .itemInfo img{
        width: 8.5vw;
        height: auto;
        position: relative;
    }



  }

</style>